module.exports = __webpack_public_path__ + "img/scrub11.3993358b.jpg";